import { Button } from '@mui/material';
import { useState } from 'react';

import ConditionManualRuleEditor, {
  ResourceOperation,
} from './ConditionManualRuleEditor';

interface AddIncludeExcludeActionButtonsProps {
  onIncludeAdded: (resourceId: string) => void;
  onExcludeAdded: (resourceId: string) => void;
}

export const AddIncludeExcludeActionButtons = (
  props: AddIncludeExcludeActionButtonsProps
) => {
  const { onExcludeAdded, onIncludeAdded } = props;
  const [addIncExc, setAddIncExc] = useState(false);

  return (
    <div style={{ marginTop: '24px' }}>
      {addIncExc && (
        <ConditionManualRuleEditor
          onFinish={(operation, resourceId) => {
            if (resourceId && resourceId.length > 8) {
              if (operation === ResourceOperation.Include) {
                onIncludeAdded(resourceId);
              } else {
                onExcludeAdded(resourceId);
              }
            }

            setAddIncExc(false);
          }}
          onAbort={() => {
            setAddIncExc(false);
          }}
        />
      )}
      {!addIncExc && (
        <Button
          onClick={() => {
            setAddIncExc(true);
          }}
          variant='outlined'
          sx={{
            borderColor: 'transparent',
            width: 32,
            height: 32,
            padding: 0,
            minWidth: 0,
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <i className='material-symbols-add-rounded text-xl' />
        </Button>
      )}
    </div>
  );
};
